import React from "react";

const isBlank = (v) => v === undefined || v === null || v === "";

// Label/value cell used inside a `.pv-grid` (styles in AdminPanel.css).
export const Field = ({ label, value, mono = false, wide = false, children }) => (
  <div className={`pv-field${wide ? " pv-field-wide" : ""}`}>
    <div className="pv-label">{label}</div>
    <div className={`pv-value${mono ? " pv-mono" : ""}`}>
      {children ?? (isBlank(value) ? "—" : String(value))}
    </div>
  </div>
);

// Two-letter avatar text for a person, falling back to the email initial.
export const initials = (user) =>
  `${(user.first_name || "")[0] || ""}${(user.last_name || "")[0] || ""}`.toUpperCase() ||
  (user.email || "?")[0].toUpperCase();

const RELATIVE_UNITS = [
  ["year", 365 * 24 * 3600],
  ["month", 30 * 24 * 3600],
  ["week", 7 * 24 * 3600],
  ["day", 24 * 3600],
  ["hour", 3600],
  ["minute", 60],
];

const relativeTime = (date) => {
  const seconds = Math.round((date.getTime() - Date.now()) / 1000);
  const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: "auto" });
  for (const [unit, size] of RELATIVE_UNITS) {
    if (Math.abs(seconds) >= size) return rtf.format(Math.round(seconds / size), unit);
  }
  return "just now";
};

// "Jul 14, 2025, 7:43 AM" with a muted "3 months ago" under it. Falls back to
// the raw value when it isn't a parseable date.
export const FriendlyDate = ({ value }) => {
  if (isBlank(value)) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return (
    <>
      <span>
        {date.toLocaleString(undefined, {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "2-digit",
        })}
      </span>
      <span className="pv-rel">{relativeTime(date)}</span>
    </>
  );
};
